module.exports = __webpack_public_path__ + "img/bonusgroup-small.f85f13e5.svg";